const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy_mono/apps/pinktool/src/routes/_app/transactions.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { vstack } from "@packages/panda-generated/patterns";
export const Route = createFileRoute("/_app/transactions")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});